import call from '@/utils/api/call'

export async function fetchLocalization() {
  return call.get('/api/model/localization/').then(({data}) => {
    if (
      typeof data === 'object' &&
      data !== null &&
      'locale' in data &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- its safe
      typeof data.locale === 'string' &&
      'geo_location' in data &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- its safe
      typeof data.geo_location === 'string'
    ) {
      return data as {locale: string; geo_location: string}
    }
    throw new Error('Invalid data format', {cause: data})
  })
}
